exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-control-label[data-v-4d37c3a2]::after {\r\n  top: 0.1rem;\n}\n.custom-control-label[data-v-4d37c3a2]::before {\r\n  top: 0.1rem;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4d37c3a2","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Checkbox.vue
// module id = DIAm
// module chunks = 70